import type { ReactNode } from 'react';
import classes from './MainPane.module.css';

interface MainPaneProps {
  children: ReactNode;
}

export const MainPane = (props: MainPaneProps) => {
  return <main className={classes.MainPane}>{props.children}</main>;
};
